const ufeApi = require('services/api/ufeApi');

function getServicesAndEvents(token, { language, country, preferredStoreId, preferredZipCode }) {
    const languageLowerCase = language.toLowerCase();
    const sdnDomain = Sephora.configurationSettings.sdnApiHost;
    const url = `${sdnDomain}/v1/store-experience/service/event/services?storeId=${preferredStoreId}&zipCode=${preferredZipCode}&channel=web&locale=${languageLowerCase}-${country}&country=${country}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            headers: { 'x-requested-source': 'rwd', authorization: `Bearer ${token}` }
        })
        .then(data => data);
}

module.exports = { getServicesAndEvents };
